import { render } from "./PhoneLoginView.vue?vue&type=template&id=6cd61098&scoped=true"
import script from "./PhoneLoginView.vue?vue&type=script&lang=js"
export * from "./PhoneLoginView.vue?vue&type=script&lang=js"

import "./PhoneLoginView.vue?vue&type=style&index=0&id=6cd61098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd61098"]])

export default __exports__